import { create } from 'zustand'

interface EmailVerificationModalStore {
   isOpen: boolean
   name: string
   icon: string
   iconClassName: string
   openEmailVerificationModal: (config: {
      name: string
      icon?: string
      iconClassName?: string
   }) => void
   closeEmailVerificationModal: () => void
}

export const useEmailVerificationModalStore = create<EmailVerificationModalStore>(
   (set) => ({
      isOpen: false,
      name: 'Jon Doe',
      icon: 'ForwardFlow',
      iconClassName: 'scale-[5] fill-white',
      openEmailVerificationModal: (config) =>
         set({
            isOpen: true,
            name: config.name,
            icon: config.icon || 'ForwardFlow',
            iconClassName: config.iconClassName || 'scale-[5] fill-white',
         }),
      closeEmailVerificationModal: () => set({ isOpen: false }),
   })
)
